import React from "react";
import PropTypes from "prop-types";
import Tree from "rc-tree";
import "../../../css/tree.css";
import { connect } from "react-redux";
import Icon from "../../../components/Icon";
import { message } from "../../../actions";
import { getBlocks, patchBlocks } from "../actions/Blocks";
import { patchQuestions } from "../actions/Questions";
import { patchAnswers } from "../actions/Answers";
import { patchQuestionnaires } from "../actions/Questionnaires";

const mapStateToProps = ( state ) =>
{
	return {
		createdTreeKey: state.createdTreeKey,
		questionnaires: state.questionnaires,
		blocksByQuestionnaireId: state.blocksByQuestionnaireId
	};
};

const mapDispatchToProps = ( dispatch ) =>
{
	return {
		patchQuestionnaires: ( formData ) =>
		{
			dispatch( patchQuestionnaires( formData ) );
		},
		getBlocks: ( questionnaireId ) =>
		{
			dispatch( getBlocks( questionnaireId ) );
		},
		patchBlocks: ( a_formData, a_block_id, a_questionnaireId, a_params ) =>
		{
			dispatch( patchBlocks( a_formData, a_block_id, a_questionnaireId, a_params ) );
		},
		patchQuestions: ( a_formData, a_question_id, a_block_id, a_questionnaire_id, a_params ) =>
		{
			dispatch( patchQuestions( a_formData, a_question_id, a_block_id, a_questionnaire_id, a_params ) );
		},
		patchAnswers: ( a_formData, a_survey_answer_id, a_question_id, a_block_id, a_questionnaire_id, a_params ) =>
		{
			dispatch( patchAnswers( a_formData, a_survey_answer_id, a_question_id, a_block_id, a_questionnaire_id, a_params ) );
		},
		message: ( a_message, a_type, a_timeout ) =>
		{
			dispatch( message( a_message, a_type, a_timeout ) );
		}
	};
};

class QuestionnaireTree extends React.Component
{
	constructor( props )
	{
		super( props );
		
		this.state = {
			selectedKey: null,
			expandedKeys: [ `questionnaire-${this.props.treePrefix}-${this.props.questionnaireId}` ],
			show: props.show ? props.show : "regularTree",
			onDragClassName: ""
		};
		
	} // function constructor(...)
	
	componentDidMount()
	{
		const { createdTreeKey } = { ...this.props };
		
		this.setState(
			{
				selectedKey: createdTreeKey ? createdTreeKey : null,
				// Alle aufklappen/zuklappen
				expandedKeys: this.getExpandedKeys()
			}
		);
		
	} // function componentDidMount()
	
	/**
	 * Wird jedes Mal aufgerufen, wenn sich etwas an der Komponente geändert hat.
	 *
	 * @param prevProps Die vorherigen Eigenschaften
	 * @param prevState Der vorherige State
	 * @param snapshot
	 */
	componentDidUpdate( prevProps, prevState, snapshot )
	{
		const { questionnaireId, blocksByQuestionnaireId, show, createdTreeKey, treePrefix } = { ...this.props };
		
		let state = {};
		if ( prevProps.show !== show )
		{
			state["show"] = show;
		}
		
		// Alle aufklappen/zuklappen
		const expandedKeys = this.getExpandedKeys();
		if ( JSON.stringify( prevState.expandedKeys ) !== JSON.stringify( expandedKeys ) )
		{
			state["expandedKeys"] = expandedKeys;
		}
		
		// Wenn ein neuer Knoten in "menuTree" angelegt wurde, dann diesen auswählen
		if ( prevProps.createdTreeKey !== createdTreeKey )
		{
			const keyParts = createdTreeKey.split( "-" );
			if ( keyParts[0] === "menuTree" && treePrefix === "menuTree" )
			{
				state["selectedKey"] = createdTreeKey;
				const { selectedNode } = this.toTree( blocksByQuestionnaireId[questionnaireId], createdTreeKey );
				this.props.onSelect( [ createdTreeKey ], { node: { props: selectedNode }, created: true } );
			}
		}
		
		if ( Object.keys( state ).length > 0 )
		{
			this.setState( state );
		}
		
	} // function componentDidUpdate(...)
	
	/**
	 * Gibt die Ids der Knotenpunkte zurück.
	 */
	getExpandedKeys()
	{
		const { collapseOrExpandAll, treePrefix, questionnaireId } = { ...this.props };
		
		// Alle aufklappen
		let expandedKeys = [];
		if ( collapseOrExpandAll === "expand" )
		{
			expandedKeys = this.treeNodeKeys;
		}
		// Alle zuklappen
		else if ( collapseOrExpandAll === "collapse" )
		{
			expandedKeys = [ `questionnaire-${treePrefix}-${questionnaireId}` ];
		}
		
		return expandedKeys;
		
	} // function getExpandedKeys()
	
	/**
	 * Event: Wenn ein Element aus dem Baum ausgeklappt wird.
	 *
	 * @param expandedKeys
	 * @param info
	 */
	onExpand( expandedKeys, info )
	{
		// Aufgeklappt
		this.setState(
			{
				expandedKeys: expandedKeys
			}
		);
		
	} // function onExpand(...)
	
	/**
	 * Gibt das Icon für einen Knoten zurück
	 *
	 * @returns {ReactDOM}
	 */
	getIcon( a_iconName, a_class )
	{
		return <Icon size={14} iconName={a_iconName} className={a_class}/>;
		
	} // function getIcon(...)
	
	/**
	 * Gibt die römische Zahl für die Dezimalzahl zurück
	 *
	 * @returns {String}
	 */
	static decimalToRoman( a_int )
	{
		// Wandelt die Dezimalzahl in ein String um
		let decimal = "" + a_int;
		
		// Entferne vorangestellte Nullen
		while ( decimal.substr( 0, 1 ) === "0" )
		{
			decimal = decimal.substring( 1, decimal.length );
		}
		
		// Wandelt den String zur Dezimalzahl wieder um
		let int = parseInt( decimal );
		
		// Zähle die 1000
		let thousand = 0;
		while ( int > 1000 )
		{
			int -= 1000;
			thousand++;
		}
		
		// Wandelt die Dezimalzahl ohne die Tausender in ein String um
		decimal = int + "";
		
		// Römische Zahlen bestimmen
		let result = "";
		const length = decimal.length;
		
		// Römische Zahlen die angehangen werden dürfen (8 = "VIII"), aufsteigend sortiert.
		const adds = [ "I", "X", "C", "M" ];
		
		// Römische Zahlen die nicht angehangen werden dürfen ("VV" ist nicht möglich, richtig ist "X"), aufsteigend sortiert.
		const noAdds = [ "V", "L", "D" ];
		
		// Durchlafe jede Stelle und wandel die Zahl um
		for ( let i = 0; i < length; i++ )
		{
			// Aktuelle Stelle der Dezimalzahl
			const d = decimal.substr( i, 1 );
			
			// Position ändern
			const pos = length - 1 - i;
			
			switch ( d )
			{
				case "1":
				case "2":
				case "3":
					// Zu Einzelnen addierbaren römischen Zahlen ("III", "XXX") umwandeln
					for ( let j = 0; j < d; j++ )
					{
						result += adds[pos];
					}
					break;
				case "4":
					// Zu der doppelten addierbaren römischen Zahl ("IV") umwandeln
					result += adds[pos] + noAdds[pos];
					break;
				case "5":
					// nicht addirbare Zahl umwandeln
					result += noAdds[pos];
					break;
				case "6":
				case "7":
				case "8":
					// nicht addierbare Buchstaben ("V", "L", "D")
					result += noAdds[pos];
					for ( let k = 5; k < d; k++ )
					{
						result += adds[pos];
					}
					break;
				case "9":
					// Wie bei der 4, jedoch mit addierbaren Buchstaben
					result += adds[pos] + adds[pos + 1];
					break;
				case "0":
				default:
					// Nullen werden nicht umgewandelt
					break;
			}
		}
		
		// Die 1000 Stellen die abgezogen wurden jetzt anhängen
		for ( let m = 0; m < thousand; m++ )
		{
			result = "M" + result;
		}
		
		// Rückgabe der römischen Großbuchstaben
		return result.toUpperCase();
	}
	
	/**
	 * Gibt den Knoten für Blöcke, Fragen und Antworten zurück.
	 *
	 * @param {[Object]} a_node
	 *
	 * @return {Array}
	 */
	getTreeNode( a_node )
	{
		const { treePrefix, disabled = [ "topNode" ], disabledQuestionId } = { ...this.props };
		
		const node = {};
		node.className = `tree-${a_node.type}`;
		node.key = `${treePrefix}-${a_node.type}-${a_node.id ? a_node.id : a_node.index}`;
		node.icon = this.getIcon( a_node.type );
		node.type = a_node.type;
		node.id = a_node.id;
		node.label = a_node.title;
		node.dragOverGapBottom = false;
		node.children = [];
		
		let preTitle = "";
		switch ( a_node.type )
		{
			case "blocks":
				switch ( this.state.show )
				{
					case "shortTree":
						preTitle = QuestionnaireTree.decimalToRoman( a_node.sort_id );
						break;
					case "longTree":
						preTitle = <React.Fragment><strong>Block {a_node.sort_id}</strong> {a_node.title}</React.Fragment>;
						break;
					case "regularTree":
					default:
						preTitle = `Block ${a_node.sort_id}`;
						break;
				}
				node.title = [
					<span key={"tooltip"} className={"tooltip"}>{preTitle}</span>,
					<span key={"tooltiptext"} className={"tooltiptext"}>{a_node.title}</span>
				];
				node.sortId = a_node.sort_id;
				node.disabled = disabled.indexOf( a_node.type ) !== -1;
				break;
			case "questions":
				switch ( this.state.show )
				{
					case "shortTree":
						preTitle = QuestionnaireTree.decimalToRoman( a_node.sort_id );
						break;
					case "longTree":
						// Fragen ohne HTML
						preTitle =
							<React.Fragment><strong>Frage {a_node.sort_id}</strong> {a_node.question.replace( /<[^>]+>/g, "" )}</React.Fragment>;
						break;
					case "regularTree":
					default:
						preTitle = `Frage ${a_node.sort_id}`;
						break;
				}
				node.title = [
					<div key={"tooltip"} className={"tooltip"}>{preTitle}</div>,
					<div key={"tooltiptext"} className={"tooltiptext"}>
						<label>Frage:</label>
						<div dangerouslySetInnerHTML={{ __html: a_node.question }}/>
						<br/>
						<label>Hinweistext:</label>
						<div dangerouslySetInnerHTML={{ __html: a_node.note }}/>
					</div>
				];
				node.binary = a_node.binary;
				node.breadcrumb = <React.Fragment>Block {a_node.blockSortId}: {a_node.blockTitle}</React.Fragment>;
				node.block_id = a_node.block_id;
				node.sortId = a_node.sort_id;
				// Deaktiviere wenn auf sich selbst referenziert wird oder der Knoten deaktiviert werden soll
				node.disabled = disabledQuestionId === a_node.id || disabled.indexOf( "questions" ) !== -1;
				break;
			case "answers":
				switch ( this.state.show )
				{
					case "shortTree":
						preTitle = QuestionnaireTree.decimalToRoman( a_node.index );
						break;
					case "longTree":
						preTitle = <React.Fragment><strong>Antwort {a_node.index}</strong> {a_node.title}</React.Fragment>;
						break;
					case "regularTree":
					default:
						preTitle = a_node.binary ?
							a_node.index === 1 ? "Antwort: Ja" : "Antwort: Nein"
							: `Antwort ${a_node.index}`;
						break;
				}
				node.title = [
					<span key={"tooltip"} className={"tooltip"}>{preTitle}</span>,
					<span key={"tooltiptext"} className={"tooltiptext"}>{a_node.title}</span>
				];
				node.icon = this.getIcon( a_node.binary ? "binaryAnswer" : "answerList" );
				node.binary = a_node.binary;
				node.breadcrumb = <React.Fragment>
					<strong><u>Block {a_node.blockSortId}:</u></strong> {a_node.blockTitle}<br/>
					<span className={"line"}>
						<strong><u>Frage {a_node.questionSortId}:</u></strong> {a_node.question.replace( /<[^>]+>/g, "" )}
					</span>
				</React.Fragment>;
				node.block_id = a_node.block_id;
				node.question_id = a_node.question_id;
				node.sortId = a_node.index.toString();
				node.disabled = disabled.indexOf( "answers" ) !== -1;
				break;
			default:
				switch ( this.state.show )
				{
					case "shortTree":
						preTitle = QuestionnaireTree.decimalToRoman( a_node.sort_id );
						break;
					case "longTree":
						preTitle = <React.Fragment><strong>Block {a_node.sort_id}</strong> {a_node.title}</React.Fragment>;
						break;
					case "regularTree":
					default:
						preTitle = `Block ${a_node.sort_id}`;
						break;
				}
				node.title = [
					<span key={"tooltip"} className={"tooltip"}>{preTitle}</span>,
					<span key={"tooltiptext"} className={"tooltiptext"}>{a_node.title}</span>
				];
				node.sortId = a_node.sort_id;
				node.disabled = disabled.indexOf( a_node.type ) !== -1;
				break;
		}
		
		return node;
		
	} // function getTreeNode(...)
	
	/**
	 * Gibt den Knoten für Blöcke, Fragen und Antworten zurück.
	 *
	 * @param {[Object]} a_node
	 *
	 * @return {Array}
	 */
	getTemplateTreeNode( a_node )
	{
		const { treePrefix, disabled = [ "topNode" ] } = { ...this.props };
		
		const templateTitle = "Neue Antwort";
		const templateNode = [];
		templateNode.type = "answers";
		templateNode.binary = a_node.binary;
		templateNode.breadcrumb = <React.Fragment>
			<strong><u>Block {a_node.blockSortId}:</u></strong> {a_node.blockTitle}<br/>
			<span className={"line"}>
					<strong><u>Frage {a_node.questionSortId}:</u></strong> {a_node.question ? a_node.question.replace( /<[^>]+>/g, "" ) : ""}
				</span>
		</React.Fragment>;
		templateNode.block_id = a_node.block_id;
		templateNode.question_id = a_node.question_id;
		templateNode.disabled = disabled.indexOf( "answers" ) !== -1;
		templateNode.icon = this.getIcon( a_node.binary ? "binaryAnswer" : "answerList", "red-text" );
		templateNode.key = `${treePrefix}-${templateNode.type}-block-${a_node.block_id}-question-${a_node.question_id}-temp-${a_node.index}`;
		templateNode.sortId = a_node.index.toString();
		templateNode.label = templateTitle;
		templateNode.dragOverGapBottom = false;
		
		let preTitle = "";
		switch ( this.state.show )
		{
			case "shortTree":
				preTitle = QuestionnaireTree.decimalToRoman( a_node.index );
				break;
			case "longTree":
				preTitle = <React.Fragment><strong>Antwort {a_node.index}</strong> {templateTitle}</React.Fragment>;
				break;
			case "regularTree":
			default:
				preTitle = a_node.binary ?
					a_node.index === 1 ? "Antwort: Ja" : "Antwort: Nein"
					: `Antwort ${a_node.index}`;
				break;
		}
		templateNode.title = <span key={"red-text"} className={"tooltip red-text"}>{preTitle}</span>;
		
		return templateNode;
		
	} // function getTemplateTreeNode(...)
	
	/**
	 * Wandelt das Array der Blöcke, Fragen und Antworten in einen darstellbaren Baum um.
	 *
	 * @param {[Object]} a_blocks
	 * @param {String} a_selectedKey
	 *
	 * @return {Array}
	 */
	toTree( a_blocks, a_selectedKey )
	{
		const { questionnaireId, questionnaires, treePrefix, showable = [ "all" ], disabled = [ "topNode" ] } = { ...this.props };
		const selectedKey = a_selectedKey ? a_selectedKey : this.state.selectedKey;
		this.treeNodeKeys = [];
		this.selectedNode = {};
		this.treeInProgress = [];
		const blocks = [];
		this.treeInProgress.push(
			{
				id: questionnaireId,
				key: `questionnaire-${treePrefix}-${questionnaireId}`,
				parentId: null,
				title: `Imera: ${questionnaires[questionnaireId].title}`,
				children: blocks,
				disabled: disabled.indexOf( "topNode" ) !== -1
			}
		);
		this.treeNodeKeys.push( `questionnaire-${treePrefix}-${questionnaireId}` );
		
		if ( a_blocks )
		{
			const showableAll = showable.indexOf( "all" ) !== -1;
			const blockKeys = Object.keys( a_blocks );
			
			// Blocks durchlaufen
			( showable.indexOf( "blocks" ) !== -1 || showableAll ) &&
			blockKeys.sort( ( block1, block2 ) => a_blocks[block1].sort_id - a_blocks[block2].sort_id )
				.forEach(
					( a_blockKey ) =>
					{
						const block = a_blocks[a_blockKey];
						const blockNode = this.getTreeNode( { ...block, type: "blocks" } );
						this.treeNodeKeys.push( blockNode.key );
						if ( blockNode.key === selectedKey )
						{
							this.selectedNode = blockNode;
						}
						const questionKeys = Object.keys( block.questions );
						
						// Fragen durchlaufen
						( showable.indexOf( "questions" ) !== -1 || showableAll ) &&
						questionKeys.sort( ( question1, question2 ) => block.questions[question1].sort_id - block.questions[question2].sort_id )
							.forEach(
								( a_questionKey ) =>
								{
									const question = block.questions[a_questionKey];
									const questionNode = this.getTreeNode( { ...question, type: "questions", blockSortId: block.sort_id, blockTitle: block.title } );
									this.treeNodeKeys.push( questionNode.key );
									if ( questionNode.key === selectedKey )
									{
										this.selectedNode = questionNode;
									}
									
									// Antworten durchlaufen
									if ( showableAll || showable.indexOf( "answers" ) !== -1 )
									{
										const sortedAnswerKeys = Object.keys( question.answers ).sort( ( answer1, answer2 ) => question.answers[answer1].sort_id - question.answers[answer2].sort_id );
										let i = 1;
										let maxKey = Object.keys( sortedAnswerKeys ).length;
										
										// Es werden mindestens zwei Datensätze erwartet
										maxKey = maxKey >= 2 ? maxKey : 2;
										
										// Alle Datensätze durchlaufen und ggf. Platzhalter anlegen
										Object.keys( sortedAnswerKeys ).forEach(
											a_answerKey =>
											{
												const answer = question.answers[sortedAnswerKeys[a_answerKey]];
												const sortId = parseInt( answer.sort_id );
												
												// Lücken mit einem Template auffüllen
												while ( sortId !== i && i <= maxKey )
												{
													const answerTemplateNode = this.getTemplateTreeNode( {
														...answer,
														type: "answers",
														question: question.question,
														binary: question.binary,
														block_id: question.block_id,
														question_id: question.id,
														questionSortId: question.sort_id,
														blockTitle: block.title,
														blockSortId: block.sort_id,
														index: i++,
														sortedAnswerKeys: sortedAnswerKeys
													} );
													this.treeNodeKeys.push( answerTemplateNode.key );
													questionNode.children.push( answerTemplateNode );
												}
												
												// oder Datensatz hinzufügen
												const answerNode = this.getTreeNode( {
													...answer,
													type: "answers",
													question: question.question,
													binary: question.binary,
													block_id: question.block_id,
													question_id: question.id,
													questionSortId: question.sort_id,
													blockTitle: block.title,
													blockSortId: block.sort_id,
													index: i++,
													sortedAnswerKeys: sortedAnswerKeys
												} );
												if ( answerNode.key === selectedKey )
												{
													this.selectedNode = answerNode;
												}
												
												this.treeNodeKeys.push( answerNode.key );
												questionNode.children.push( answerNode );
											}
										);
										
										// Wenn kein oder nur der erste Datensatz vorhanden ist dann Template hinzufügen
										while ( sortedAnswerKeys.length <= 2 && i <= 2 )
										{
											const answerTemplateNode = this.getTemplateTreeNode( {
												type: "answers",
												question: question.question,
												binary: question.binary,
												block_id: question.block_id,
												question_id: question.id,
												questionSortId: question.sort_id,
												blockTitle: block.title,
												blockSortId: block.sort_id,
												index: i,
												sortedAnswerKeys: sortedAnswerKeys
											} );
											this.treeNodeKeys.push( answerTemplateNode.key );
											questionNode.children.push( answerTemplateNode );
											
											i++;
										}
									}
									
									blockNode.children.push( questionNode );
								}
							);
						
						blocks.push( blockNode );
					}
				);
		}
		
		return { treeInProgress: this.treeInProgress, treeNodeKeys: this.treeNodeKeys, selectedNode: this.selectedNode };
		
	} // function toTree(...)
	
	/**
	 * Event: Wenn eine Auswahlt getroffen wird, dann die Informationen anzeigen.
	 *
	 * @param {[string]} selectedKeys Alle ausgewählten Keys (Ids der Elemente)
	 * @param {Object} info Informationen zu der angeklickten Auswahl
	 */
	onSelect( selectedKeys, info )
	{
		this.setState( { selectedKey: selectedKeys[0] } );
		this.props.onSelect( selectedKeys, info );
		
	} // function onSelect(...)
	
	/**
	 * Event: Wenn ein Element verschoben werden soll, die Klasse hinzufügen um die Verschiebungslinien teilweise auszublenden.
	 */
	onDragStart()
	{
		this.setState( { onDragClassName: "on-drag" } );
		
	} // function onDragStart(...)
	
	/**
	 * Event: Wenn ein Element verschoben wurde, die Klasse entfernen.
	 */
	onDragEnd()
	{
		this.setState( { onDragClassName: "" } );
		
	} // function onDragEnd(...)
	
	/**
	 * Event: Wenn ein Element beim Drag & Drop in ein anderes Element (also als Unterelement) verschoben wird.
	 * Hier wird das Element dann aufgeklappt.
	 *
	 * @param targetNode Alle Infos zum targetNode
	 */
	onDrop( targetNode )
	{
		const { questionnaires, blocksByQuestionnaireId, questionnaireId } = { ...this.props };
		
		// Zu verschiebende Element
		const dragNode = targetNode.dragNode.props;
		// Nachfolgende Element
		const dropNode = targetNode.node.props;
		const dropNodeSortId = parseInt( dropNode.sortId );
		
		// Leere Hüllen nicht verschieben
		if ( dragNode.type === "answers" && typeof dragNode.id === "undefined" )
		{
			return this.props.message( "Bevor die Antwort verschoben werden kann, muss diese zuerst angelegt werden.", "error" );
		}
		
		const childrenSortId = dropNode.children.length && Object.keys( dropNode.children ).filter( a_key => dropNode.children[a_key].props.hasOwnProperty( "id" ) ).length;
		const dropNodePosistion = dropNode.pos.split( "-" );
		const dropPosition = Number( dropNodePosistion[dropNodePosistion.length - 1] );
		
		// Neue Position herausfinden
		let newSortId = 1;
		// Innerhalb der Frage
		if ( ( dragNode.type === "blocks" && dropNode.type === "blocks" ) ||
			( dragNode.type === "questions" && dropNode.type === "questions" && dragNode.block_id === dropNode.block_id ) ||
			( dragNode.type === "answers" && dropNode.type === "answers" && dragNode.question_id === dropNode.question_id ) )
		{
			// Wenn das Element nicht wirklich verschoben wird, dann nichts tun
			if ( dropPosition === parseInt( dragNode.sortId ) && targetNode.dropPosition < dropPosition )
			{
				return;
			}
			else if ( dropPosition > parseInt( dragNode.sortId ) )
			{
				newSortId = dropPosition + 1;
			}
			else
			{
				newSortId = dropNodeSortId;
			}
		}
		else
		{
			newSortId = dropPosition + 1;
		}
		
		// Gewähltes Element nach Typ
		switch ( dragNode.type )
		{
			case "blocks":
				// Neuer Pfad nach Typ
				switch ( dropNode.type )
				{
					case "blocks":
						// Wenn der Block zu einen anderen Block verschoben wird
						if ( !targetNode.dropToGap )
						{
							return this.props.message( "Ein Block darf keinen Block beinhalten.", "error" );
						}
						this.props.patchBlocks( { sort_id: newSortId }, dragNode.id, questionnaireId, "sort" );
						break;
					case "questions":
						// Wenn der Block zu einer Frage verschoben wird
						return this.props.message( "Eine Frage darf keinen Block beinhalten.", "error" );
					case "answers":
						/*// TODO Wenn die Antwort nicht das letzte Element in der letzten Frage ist
						 if ( ??? )
						 {
						 return this.props.message( "Der gewählte Block kann nicht zu einer Antwort zugewiesen werden.", "error" );
						 }
						 this.props.patchBlocks( { sort_id: childrenSortId }, dragNode.id, questionnaireId, "sort" );*/
						
						// Wenn der Block zu einer Antwort verschoben wird
						return this.props.message( "Eine Antwort darf keinen Block beinhalten.", "error" );
					
					default:
						return this.props.message( "Es ist ein Fehler beim Verschieben aufgetretten.", "error" );
				}
				break;
			
			case "questions":
				// Neuer Pfad nach Typ
				switch ( dropNode.type )
				{
					case "blocks":
						// Wenn die Frage zu einem Block verschoben wird
						if ( targetNode.dropToGap )
						{
							return this.props.message( "Eine Frage darf nicht auf der Blockebene platziert werden.", "error" );
						}
						
						// Wenn die Frage innerhalb des Blocks verschoben wird
						if ( dragNode.block_id === dropNode.id )
						{
							// Wenn der Block ausgewählt wird und das bereits das letzte Element ist.
							if ( childrenSortId === parseInt( dragNode.sortId ) )
							{
								return this.props.message( "Die gewählte Frage wurde nicht verschoben, da keine Änderung vorliegt.", "info", 5000 );
							}
							
							this.props.patchQuestions( { sort_id: childrenSortId > 0 ? childrenSortId : 1 }, dragNode.id, dragNode.block_id, questionnaireId, "sort" );
						}
						// Ans Ende im gewählten Block
						else
						{
							this.props.patchQuestions( { sort_id: childrenSortId > 0 ? childrenSortId + 1 : 1, block_id: dropNode.id }, dragNode.id, dragNode.block_id, questionnaireId, "move" );
						}
						break;
					
					case "questions":
						// Wenn die Frage zu einer anderen Frage verschoben wird
						if ( !targetNode.dropToGap )
						{
							return this.props.message( "Die gewählte Frage kann nicht bei Blöcken positioniert werden.", "error" );
						}
						
						// Wenn die Frage innerhalb des Blocks verschoben wird
						if ( dragNode.block_id === dropNode.block_id )
						{
							this.props.patchQuestions( { sort_id: newSortId }, dragNode.id, dragNode.block_id, questionnaireId, "sort" );
						}
						// Ans Ende im gewählten Block
						else
						{
							this.props.patchQuestions( { sort_id: newSortId, block_id: dropNode.block_id }, dragNode.id, dragNode.block_id, questionnaireId, "move" );
						}
						break;
					
					case "answers":
						// TODO Wenn die Antwort nicht das letzte Element in der letzten Frage ist
						// Wenn die Frage zu einer Antwort verschoben wird
						return this.props.message( "Die gewählte Frage kann nicht zu einer Antwort zugewiesen werden.", "error" );
					
					default:
						return this.props.message( "Es ist ein Fehler beim Verschieben aufgetretten.", "error" );
				}
				break;
			
			case "answers":
				// Neuer Pfad nach Typ
				switch ( dropNode.type )
				{
					case "blocks":
						// Wenn die Antwort zu einem Block verschoben wird
						return this.props.message( "Eine Antwort darf nicht auf der Blockebene plaziert werden.", "error" );
					
					case "questions":
						// Wenn die Antwort zu einem Block verschoben wird
						if ( targetNode.dropToGap )
						{
							return this.props.message( "Eine Antwort darf nicht auf der Frageebene plaziert werden.", "error" );
						}
						
						// Wenn die Antwort innerhalb der Frage verschoben wird
						if ( dragNode.question_id === dropNode.id )
						{
							// Wenn die Frage ausgewählt wird und das bereits das letzte Element ist.
							if ( childrenSortId === parseInt( dragNode.sortId ) )
							{
								return this.props.message( "Die gewählte Antwort wurde nicht verschoben, da keine Änderung vorliegt.", "info", 5000 );
							}
							
							this.props.patchAnswers( { sort_id: childrenSortId > 0 ? childrenSortId : 1 }, dragNode.id, dragNode.question_id, dragNode.block_id, questionnaireId, "sort" );
						}
						// Ans Ende der gewählten Frage
						else
						{
							this.props.patchAnswers(
								{ sort_id: childrenSortId > 0 ? childrenSortId + 1 : 1, block_id: dropNode.block_id, question_id: dropNode.id, drag_question_id: dragNode.question_id },
								dragNode.id, dragNode.question_id, dragNode.block_id, questionnaireId, "move" );
						}
						break;
					
					case "answers":
						// Prüfe ob die Frage weitere Antworten haben darf
						if ( dropNode.binary && dragNode.question_id !== dropNode.question_id && Object.keys( blocksByQuestionnaireId[questionnaireId][dropNode.block_id]["questions"][dropNode.question_id]["answers"] ).length >= 2 )
						{
							return this.props.message( "Die Frage (Ja|Nein) darf keine weiteren Antworten beinhalten.", "error" );
						}
						
						// Wenn die Antwort innerhalb der Frage verschoben wird
						if ( dragNode.question_id === dropNode.question_id )
						{
							this.props.patchAnswers( { sort_id: newSortId }, dragNode.id, dragNode.question_id, dragNode.block_id, questionnaireId, "sort" );
						}
						// Ans Ende der gewählten Frage
						else
						{
							this.props.patchAnswers(
								{ sort_id: newSortId, block_id: dropNode.block_id, question_id: dropNode.question_id, drag_question_id: dragNode.question_id },
								dragNode.id, dragNode.question_id, dragNode.block_id, questionnaireId, "move" );
						}
						break;
					
					default:
						return this.props.message( "Es ist ein Fehler beim Verschieben aufgetretten.", "error" );
				}
				
				break;
			
			default:
				return this.props.message( "Es ist ein Fehler beim Verschieben aufgetretten.", "error" );
		}
		
		// this.props.onSelect( dropNode.key, targetNode );
		
		// Fragebogen wieder deaktivieren
		if ( questionnaires[questionnaireId].active === "1" )
		{
			this.props.patchQuestionnaires( { ...questionnaires[questionnaireId], active: "0" } );
		}
		
	} // function onDrop(...)
	
	render()
	{
		// Werte entweder aus den Props lesen oder die Standardwerte benutzen
		const { className = null, questionnaireId, blocksByQuestionnaireId, draggable = false, selectedKeys = null } = { ...this.props };
		const { treeInProgress } = this.toTree( blocksByQuestionnaireId[questionnaireId] );
		
		const props = {};
		props["selectedKeys"] = selectedKeys ? selectedKeys : [ this.state.selectedKey ];
		if ( draggable )
		{
			props["draggable"] = true;
			props["onDrop"] = this.onDrop.bind( this );
			props["onDragStart"] = this.onDragStart.bind( this );
			props["onDragEnd"] = this.onDragEnd.bind( this );
		}
		if ( this.state.show )
		{
			props["className"] = this.state.show;
		}
		if ( this.state.onDragClassName )
		{
			props["className"] = `${props.className} ${this.state.onDragClassName}`;
		}
		
		return <div className={className}>
			<div className={"questionnaireTree"}>
				<Tree {...props}
				      treeData={treeInProgress}
				      onSelect={this.onSelect.bind( this )}
				      onExpand={this.onExpand.bind( this )}
				      expandedKeys={this.state.expandedKeys}
				/>
			</div>
		</div>;
		
	} // function render()
	
} // class

QuestionnaireTree.propTypes = {
	questionnaireId: PropTypes.oneOfType( [ PropTypes.number, PropTypes.string ] ).isRequired,
	onSelect: PropTypes.func.isRequired,
	treePrefix: PropTypes.string.isRequired,
	collapseOrExpandAll: PropTypes.oneOf( [ "collapse", "expand", null ] ),
	show: PropTypes.oneOf( [ "regularTree", "longTree", "shortTree", null ] ),
	disabled: PropTypes.array,
	showable: PropTypes.arrayOf( PropTypes.string ),
	disabledQuestionId: PropTypes.oneOfType( [ PropTypes.number, PropTypes.string ] ),
	selectedKeys: PropTypes.arrayOf( PropTypes.string ),
	draggable: PropTypes.bool
};

QuestionnaireTree = connect(
	mapStateToProps,
	mapDispatchToProps
)( QuestionnaireTree );

export default QuestionnaireTree;